import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot, UrlSegment, UrlTree, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import { OperationGuard } from '@app/guards';
import { AuthService, DataService, AmbassadorService, NotificationService } from '@app/services';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    
    constructor (
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private authService: AuthService,
        private dataService: DataService,
        private ambassadorService: AmbassadorService,
        private operationGuard: OperationGuard,
        private notificationService: NotificationService
    ) {}
    
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
            return this.checkTokenLogin(route);
    }
    
    async checkTokenLogin(route: ActivatedRouteSnapshot) {           
       
        let operationID = route.queryParamMap.get('o');
        let ambassadorPreviewID = route.queryParamMap.get('pa');
        if(operationID && operationID != '' 
            && ambassadorPreviewID && ambassadorPreviewID != ''){
            await this.authService.logout(false);
            await this.ambassadorService.loginPreview(operationID, ambassadorPreviewID);
            this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: {}});  
        }
            
        let statusAmbassadeur = await this.authService.checkTokenLogin(false);       
        let statusOperation = await this.operationGuard.checkOperation(route, operationID);         
        if(statusOperation !== true){
            return statusOperation;
        }
        else if(!statusAmbassadeur){
            return this.router.parseUrl('login');
        }
        
        if(this.dataService.ambassador.challenges === null){
            this.dataService.ambassador.initChallenges(this.dataService.operation);
        }
        
        //this.notificationService.init();
        
        return true;        
    }
    
}
